import { render, staticRenderFns } from "./ClientReleasesNavBar.vue?vue&type=template&id=2a939659&scoped=true"
import script from "./ClientReleasesNavBar.vue?vue&type=script&lang=js"
export * from "./ClientReleasesNavBar.vue?vue&type=script&lang=js"
import style0 from "./ClientReleasesNavBar.vue?vue&type=style&index=0&id=2a939659&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a939659",
  null
  
)

export default component.exports